// extracted by mini-css-extract-plugin
export default {"popup":"popup_popup__0m+D1","popup__item":"popup_popup__item__hCt2U","active":"popup_active__epZJa"};